import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function getSingleEventPackage(id,userId,userType) {
  var result = {return: 0,msg: 'Error',data: {}}

  let token = store.getState().user.userData.accessToken;

  let headers = {}
  if(token)
    headers = {Authorization: `Bearer ${token}`}

  if(userId)
    headers['user-id'] = userId;
  if(userType)
    headers['user-type'] = userType?.toUpperCase();


  await fetchServer({method: "Get",url: path.api+'/tourpro/events/'+id,
    headers,
  })
  .then((res) => {
    console.log(" => ",res)
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res?.error) result['msg'] = res?.error?.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;

}